import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PostMusicPage } from './post-music.page';
import { CanDeactivateGuardGuard } from '../../guard/can-deactivate-guard.guard';

const routes: Routes = [
  {
    path: 'class',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'clase',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'service',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'servicio',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'musician',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'musico',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'class/:id',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'clase/:id',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'service/:id',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
  {
    path: 'servicio/:id',
    component: PostMusicPage,
    canDeactivate: [CanDeactivateGuardGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PostMusicRoutingModule {}
